import getters from './getters';
import mutations from './mutations';

export default {
    namespaced: true,
    state() {
        return {
            authenticated: false,
            username: ""
        }
    },
    mutations,
    getters
}